import React from 'react';

import './account-management.css';

interface Props {
    children?: JSX.Element | JSX.Element[];
}

export const AccountManagement = ({ children }: Props): JSX.Element => (
        <div className="account-management-container relative">
            <div className="account-management-grid rounded bg-quarternary-100">
                {children}
            </div>
        </div>
    );
